import { formatMoney } from '../../utils/currency';

export function normalizePhone(raw: string): string {
  return raw.replace(/\D/g, '').slice(-10);
}

export function coordsFromAddress(address: string, seed = 0): [number, number] {
  const baseLng = 77.5946;
  const baseLat = 12.9716;
  let h = seed;
  for (let i = 0; i < address.length; i += 1) {
    h = (h * 31 + address.charCodeAt(i)) % 10000;
  }
  const lng = baseLng + ((h % 100) - 50) * 0.002;
  const lat = baseLat + ((Math.floor(h / 100) % 100) - 50) * 0.002;
  return [lng, lat];
}

export function haversineKm(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2
    + Math.cos((lat1 * Math.PI) / 180)
    * Math.cos((lat2 * Math.PI) / 180)
    * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function estimateDurationMin(distanceKm: number): number {
  return Math.max(5, Math.round((distanceKm / 25) * 60));
}

export function formatCurrency(amount: number, currency?: string | null): string {
  return formatMoney(amount, currency || undefined);
}

export type DispatchMode = 'MANUAL' | 'AUTOMATIC';

export interface CustomerProfile {
  _id: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
}

export interface VehicleFareOption {
  code: string;
  name: string;
  capacity?: number;
  icon?: string;
  total: number;
  subtotal?: number;
  tax?: number;
  zoneName?: string;
  loading?: boolean;
}

export interface PartnerCandidate {
  userId: string;
  name: string;
  phone?: string;
  email?: string;
  rating?: number;
  distanceKm?: number;
  vehicleType?: string;
  isOnline?: boolean;
  isAvailable?: boolean;
  score?: number;
}
